import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import { Link } from "react-router-dom";

class DetailsTopTabs extends Component {
	render() {
		return (
			<section className="tab-product m-0">
				<div className="row">
					<div className="col-sm-12 col-lg-12">
						<Tabs className="tab-content nav-material">
							<TabList className="nav nav-tabs nav-material">
								<Tab className="nav-item">
									<span className="nav-link active">
										<i className="icofont icofont-ui-home" />
										Description
									</span>
									<div className="material-border" />
								</Tab>
							</TabList>
							<TabPanel>
								<p className="mt-4 p-0">
									{this.props.item.product_discription}
								</p>
							</TabPanel>
						</Tabs>
					</div>
				</div>
			</section>
		);
	}
}

export default DetailsTopTabs;
